import script from "./ScreenInteractionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreenInteractionModal.vue?vue&type=script&setup=true&lang=js"

import "./ScreenInteractionModal.vue?vue&type=style&index=0&id=1b151295&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b151295"]])

export default __exports__